export function downloadFile(file) {
    const link = document.createElement('a');
    link.download = file;
    link.href = file;
    document.body.append(link);
    link.click();
    link.remove();
}
